import React from "react";
import rightArrow from "../assets/images/icons/rightArrow.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const Navigation = ({ id, nestedPath }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.substring(1).replaceAll("-", " ");
  return (
    <nav className="my-5 font-poppins route-navigation">
      <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold align-items-center">
        <NavLink to={"/"}>
          {" "}
          <li className="list-unstyled">HOME</li>
        </NavLink>
        {nestedPath && (
          <>
            <li className="list-unstyled">
              <img loading="lazy"  src={rightArrow} alt="" />
            </li>{" "}
            <li className="list-unstyled" onClick={() => navigate(-1)}>
              {nestedPath}
            </li>
          </>
        )}
        <li className="list-unstyled">
          <img loading="lazy"  src={rightArrow} alt="" />
        </li>
        <li className="list-unstyled text-capitalize text-dark">
          {id ? "Add" : path}
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
